import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterIcon2 } from "../assets/icons";
import { With_Team_Member_Value } from "../constants/filters";
import { setFilterModalStatus, setShowTeamInModalStatus } from '../redux/slicers/admin/sidebarSlicer';
import { setSharedPanelOpenBy, setSharedTo } from "../redux/slicers/filters/filterSlicer";
import { selectTeamMembersFilterOpen, setRightOffcanvasOpen, setSharedMemberCanvasOpen } from "../redux/slicers/uiSlicer";
import BigButton from './BigButton';

export default function FilterSideModalButton({ disabled = false, showTeamMemberFilter, showTeamFilter = null}) {
  const dispatch = useDispatch();
  const show = useSelector(selectTeamMembersFilterOpen);
  const toggleFilter = () => {
    if (showTeamFilter) {
      dispatch(setRightOffcanvasOpen(show ? false : true));
      dispatch(setSharedPanelOpenBy(show ? "" : 'admin'));
      dispatch(setSharedMemberCanvasOpen(show ? false : true))
    } else {
      dispatch(setFilterModalStatus(true));
      if (showTeamMemberFilter) {
        dispatch(setShowTeamInModalStatus(true));
      }
    }
  };

  return (
    <>
      <BigButton
        disabled={disabled}
        className="lf-btn-1  btn-lg font16 btn-primary"
        onClick={toggleFilter}
        iconAfterText={FilterIcon2}
        buttonTitle="Filters"
      />
    </>
  );
}
